import { Button } from "@controls";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface ErrorDisplayProps {
  message?: string;
  defaultTranslationKey: string;
  Illustration: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
}

export function ErrorDisplay({
  message,
  defaultTranslationKey,
  Illustration,
  actionLabel,
  onAction,
}: ErrorDisplayProps) {
  const { t } = useTranslation();
  const displayMessage = message ? t(message) : t(defaultTranslationKey);

  return (
    <div
      id="error-page"
      className="w-full h-full flex flex-col justify-center items-center gap-6"
    >
      <div className="w-full max-w-[600px] px-2">{Illustration}</div>
      <p className="text-xl text-center">{displayMessage}</p>
      {onAction && actionLabel ? (
        <div className="w-fit">
          <Button type="button" contained onClick={onAction}>
            {actionLabel}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
